import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import TitlePage from "../../../../components/TitlePage";
import ResponsiveDataTable from "../../../../components/DataTable";
import SubmitForm from "../../../../components/SubmitForm";
import ConsumoTOTVS_POST from "../../../../../backend/ConsumoTotvs";
import { ErroMsg, formatarMoeda2, formatDateColumn, parseLocaleNumber, SucessoMsg } from "../../../../contents/VariaveisGlobais";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import { format } from "date-fns";
import TitlePageTotvs from "../../../../components/TitlePageTotvs";
import { handleValorTotal } from "../../../../components/GridCell/Preco";
import getAnexoFromUrl from "../../../../../utils/anexoUrl";
import UploadFiles from "../../../../components/UploadFiles";
import { LabelInput } from "../../../../components/InputGeral/styles";
import { STituloDivider } from "../../../../components/TitlePageTotvs/styles";

const ImportarInventario = () => {
    const [carregar, setCarregar] = useState(false);
    const [inventario, setInventario] = useState([]);
    const [empresaFilial, setEmpresaFilial] = useState();
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState();
    const filePathComplete = window._env_?.REACT_APP_URL + "/uploads/modelo/Inventário.xlsx"
    const currentDate = new Date()
    const datAtual = format(currentDate, 'yyyyMMdd')

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const binaryStr = event.target.result;
                const workbook = XLSX.read(binaryStr, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // Usa a primeira linha como referência para os campos
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                const headers = jsonData[0];  // Primeira linha com os títulos
                const rows = jsonData.slice(1);  // Restante das linhas

                const data = rows.map((row) =>
                    Object.fromEntries(headers.map((header, index) => [header, row[index] || '']))
                );

                const inventarioProcessados = processarInventario(data);
                setInventario(inventarioProcessados);
            };
            
            reader.readAsBinaryString(file);
        }
    };


    const processarInventario = (data) => {
        setCarregar(true);
        let inventarioProcessados = [];

        data.forEach((row) => {
            inventarioProcessados.push({
                DATAMOV: formatarDataExcel(row["Data Inventário"]),
                UG: row["UG"],
                CC: row["Centro de Custo"],
                PRODUTO: row["Código Produto"],
                DESCRICAO: row["Descrição"],
                QTD: row["Quantidade"],
                VALOR: row["Valor Unitario"],
                LOCADO: row["Locado"],                
                OBS: row["Nota Fiscal"].trim() + ' | Patrimonio: ' + row["Patrimonio"].trim(),
                DOCUMENTO: 'INV-'+datAtual,                
                CGC: row["CNPJ"],
                NOME: row["Fornecedor"]
            });
        });

        setCarregar(false);
        return inventarioProcessados;
    };

    const formatarDataExcel = (value) => {
        if (!value) return '';

        // Caso venha como número (Excel serial date)
        if (typeof value === 'number') {
            const date = XLSX.SSF.parse_date_code(value);
            return `${date.y}-${String(date.m).padStart(2, '0')}-${String(date.d).padStart(2, '0')}`;
        }

        // Caso venha como string (DD/MM/YYYY)
        if (typeof value === 'string') {
            const [day, month, year] = value.split('/');
            if (day && month && year) {
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            }
        }

        return value; // fallback
    };

    const handleSubmit = async() => {
        const cJSON = JSON.stringify(inventario)
        setCarregar(true);
        const oRetorno = await ConsumoTOTVS_POST('INVENTARIOJOBSYSTEM', cJSON, empresaFilial)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description)
            setInventario([])
        }else{
            ErroMsg(oRetorno.description)
        }
        
        setCarregar(false);        
        
        return false
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>

                <Col md="12" xs="12" style={{ position: "relative" }}>
                    <Button
                        as="a"
                        href={filePathComplete}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="primary"
                        style={{
                            position: "absolute",
                            left: "12px",
                            top: "42px",
                            zIndex: 2,
                            whiteSpace: "nowrap"
                        }}
                    >
                        Modelo Planilha
                    </Button>
                    <TitlePageTotvs 
                        text="Importação de Inventário"
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial && (
                <>
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Selecione a Planilha</Form.Label>
                                <Form.Control
                                    type="file" 
                                    accept=".csv, .xlsx, .xlsm"
                                    onChange={handleFileUpload}
                                    />
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    { inventario && inventario.length > 0 && 
                        <SubmitForm 
                            onEnviar={handleSubmit}
                            labelEnviar="➤ Importar"
                        />
                    }

                    {  inventario && inventario.length > 0 && (
                        <ResponsiveDataTable
                            columns={[
                                {
                                    Header: 'Data',
                                    accessor: 'DATAMOV',
                                    Cell: formatDateColumn
                                },
                                {
                                    Header: 'Produto',
                                    accessor: 'PRODUTO',
                                    Cell: (item) => {
                                        const { PRODUTO, DESCRICAO } = item.row.original

                                        return <p><strong>{PRODUTO}</strong> - {DESCRICAO}</p>
                                    }
                                },
                                {
                                    Header: 'Qtde',
                                    accessor: 'QTD'
                                },
                                {
                                    Header: 'Valor',
                                    accessor: 'VALOR',
                                    Cell: handleValorTotal
                                },
                                {
                                    Header: 'UG',
                                    accessor: 'UG'
                                },
                                {
                                    Header: 'Centro de Custo',
                                    accessor: 'CC'
                                },
                                {
                                    Header: 'Locado',
                                    accessor: 'LOCADO'
                                },
                                {
                                    Header: 'Fornecedor',
                                    accessor: 'NOME',
                                    Cell: (item) => {
                                        const {NOME, CGC} = item.row.original;

                                        return <p><strong>{CGC}</strong> - {NOME}</p>
                                    }
                                },
                                {
                                    Header: 'Observação',
                                    accessor: 'OBS'
                                },                                
                            ]}
                            data={inventario}
                            habilitaBuscar={false}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default ImportarInventario;
